import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SortDirection } from '../../../dataModels/grid-list';

@Component({
    moduleId: module.id,
    selector: 'sort-list',
    templateUrl: 'sort-list.component.html'
})
export class SortList {

    @Input() field: string;

    @Input() displayName: string;

    @Output() sortChange: EventEmitter<SortDirection> = new EventEmitter<SortDirection>();

    private nextSortDirection: SortDirection = SortDirection.ASC;

    private currentSortDirection: SortDirection = null;
    
    public get isUp() {
        return this.currentSortDirection == 0;
    }


    onSort() {

        this.sortChange.emit(this.nextSortDirection);

        if (this.currentSortDirection == null) {

            this.currentSortDirection = SortDirection.ASC;
        }
        else {

            this.currentSortDirection = this.currentSortDirection == SortDirection.ASC ? SortDirection.DESC : SortDirection.ASC;
        }

        this.nextSortDirection = this.nextSortDirection == SortDirection.ASC ? SortDirection.DESC : SortDirection.ASC;
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/listView/sortList/sort-list.component.ts